<template>
    <div class="w-full pb-28 md:pb-0">
        <PlanChoiceDefault
            :products="products"
            :saving="saving"
            @select="onPlanSelected"
        />
        <div v-if="errors.length > 0" class="w-full px-4 md:px-0 pt-4">
            <Errors :errors="errors" />
        </div>
    </div>
</template>

<script setup>
import Errors from '@/components/errors.vue';
import PlanChoiceDefault from '@/components/onboarding/plan-choice/PlanChoiceDefault.vue';
import { useQuizWizard } from '@/composables/useQuizWizard';

const { saving, errors, products, onPlanSelected } = useQuizWizard();
</script>
